const Note = class Note {
    constructor() {
        this.title = '';
        this.body = '';
        this.noteType = '';
    }
};

export default Note;
